<!-- Card -->
<div class="h-screen overflow-y-auto surface-200 pb-4" [attr.data-testid]="'checkin-container'">
  <!-- Card -->
  <div class="p-2 flex align-items-center justify-content-between border-bottom-1 border-300" [attr.data-testid]="'checkin-header'">
      <div class="my-1 pl-2 text-xs md:text-sm" [attr.data-testid]="'checkin-title'">
          <strong class="text-800" *ngIf="!showSkeleton" [attr.aria-label]="'checkins-title'">{{'CLIENT_CHECKIN.CHECK_INS' | translate}}</strong>
      </div>
      <div *ngIf="!showSkeleton" [attr.data-testid]="'checkin-button-section'">
          <p-button icon="fa fa-sign-out" styleClass="md:hidden" [loading]="btnLoading" (onClick)="markCheckedIn()"
            [attr.aria-label]="'check-in-button-mobile'"
            [attr.data-testid]="'check-in-button-mobile'"></p-button>
          <p-button icon="fa fa-sign-out" [label]="'CLIENT_CHECKIN.BTN_CHECK_IN' | translate" [loading]="btnLoading" (onClick)="markCheckedIn()" styleClass="hidden md:inline-block text-sm"
            [attr.aria-label]="'check-in-button'"
            [attr.data-testid]="'check-in-button'">
          </p-button>
      </div>
      <p-skeleton *ngIf="showSkeleton" height="2rem" [attr.data-testid]="'header-skeleton'"></p-skeleton>
  </div>
  <!-- Card -->

  <!-- Details -->
  <div class="surface-0 text-sm p-3 pt-2 relative" *ngIf="client && (client.client_status !== clientStatus.Prospect || client.client_status.toString() !== clientStatus[clientStatus.Prospect])"
    [attr.data-testid]="'checkin-details'">
      <!-- Content -->
      <div class="grid my-0" *ngIf="!showSkeleton" [attr.data-testid]="'checkin-stats-grid'">

         <!-- Biostar Enrollment Card -->
          <div class="col-6 md:col-4 lg:col-6 xl:col-4" [attr.data-testid]="'enrollment-status-card'">
              <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                  <div>
                      <i class="fa fa-fingerprint mb-2 text-xl text-600 line-height-1" [attr.aria-label]="'enrollment-icon'"></i>
                      <h6 class="font-medium text-700 text-xs mb-2" [attr.aria-label]="'enrollment-status-label'">{{'BIOSTAR.ENROLLMENT_STATUS' | translate}}</h6>
                      
                      <!-- Not Enrolled State or No Credentials -->
                      <div *ngIf="!enrollmentStatus?.is_enrolled || !enrollmentStatus?.enrolled_credentials || enrollmentStatus?.enrolled_credentials?.length === 0">
                          <strong class="block text-base line-height-1 mb-2" [attr.aria-label]="'enrollment-status-value'">Configure</strong>
                          <p-button 
                              [label]="'BIOSTAR.ADD_ENROLLMENT' | translate" 
                              size="small" 
                              severity="success"
                              styleClass="text-xs p-1"
                              [loading]="enrollmentLoading"
                              (onClick)="openEnrollmentDialog()"
                              [attr.aria-label]="'add-enrollment-button'"
                              [attr.data-testid]="'add-enrollment-button'">
                          </p-button>
                      </div>

                      <!-- Enrolled State - Show Individual Types -->
                      <div *ngIf="enrollmentStatus?.is_enrolled && enrollmentStatus?.enrolled_credentials && (enrollmentStatus?.enrolled_credentials)!.length > 0">
                          <strong class="block text-base line-height-1 mb-2" [attr.aria-label]="'enrollment-status-value'">Enrolled</strong>
                          
                          <!-- Enrolled Credentials Icons Row -->
                          <div class="flex align-items-center justify-content-center gap-3 mb-2">
                              <div *ngFor="let credential of enrollmentStatus?.enrolled_credentials" 
                                   class="relative inline-block">
                                  <!-- Credential Icon with Background Circle -->
                                  <div class="flex align-items-center justify-content-center w-2rem h-2rem border-circle surface-100 border-1 border-300">
                                      <i class="fa fa-{{ getCredentialIcon(credential) }} text-sm text-600" 
                                         [attr.aria-label]="credential + '-icon'"></i>
                                  </div>
                                  
                                  <!-- Cross Icon Overlay -->
                                  <button 
                                      class="absolute flex align-items-center justify-content-center w-1rem h-1rem border-circle bg-red-500 text-white border-none cursor-pointer shadow-2"
                                      style="top: -0.25rem; right: -0.25rem; font-size: 0.6rem;"
                                      [disabled]="enrollmentLoading"
                                      (click)="clearSpecificEnrollment(credential)"
                                      [attr.aria-label]="'clear-' + credential + '-enrollment'"
                                      [attr.data-testid]="'clear-' + credential + '-enrollment'">
                                      <i class="fa fa-times"></i>
                                  </button>
                              </div>
                          </div>

                          <!-- Add More Button -->
                          <p-button 
                              [label]="'BIOSTAR.ADD_MORE' | translate" 
                              size="small" 
                              severity="secondary"
                              [outlined]="true"
                              styleClass="text-xs p-1"
                              [loading]="enrollmentLoading"
                              (onClick)="openEnrollmentDialog()"
                              [attr.aria-label]="'add-more-enrollment-button'"
                              [attr.data-testid]="'add-more-enrollment-button'">
                          </p-button>
                      </div>
                  </div>
              </div>
          </div>
          <!-- Biostar Enrollment Card -->
           
          <!-- Card -->
          <div class="col-6 md:col-4 lg:col-6 xl:col-4" [attr.data-testid]="'last-visited-date-card'">
              <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                  <div>
                      <i class="fa fa-calendar-day mb-2 text-xl text-600 line-height-1" [attr.aria-label]="'calendar-day-icon'"></i>
                      <h6 class="font-medium text-700 text-xs mb-2" [attr.aria-label]="'last-visited-date-label'">{{'CLIENT_CHECKIN.LAST_VISITED_DATE' | translate}}</h6>
                      <strong class="block text-base line-height-1" [attr.aria-label]="'last-visited-date-value'">{{ checkInDetails && checkInDetails.last_visited_date ? (checkInDetails.last_visited_date | datetimeformat: 'dd MMM yyyy') : '-' }}</strong>
                  </div>
              </div>
          </div>
          <!-- Card -->

          <!-- Card -->
          <div class="col-6 md:col-4 lg:col-6 xl:col-4" [attr.data-testid]="'last-visited-center-card'">
              <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                  <div>
                      <i class="fa fa-building mb-2 text-xl text-600 line-height-1" [attr.aria-label]="'building-icon'"></i>
                      <h6 class="font-medium text-700 text-xs mb-2" [attr.aria-label]="'last-visited-center-label'">{{'CLIENT_CHECKIN.LAST_VISITED_CENTER' | translate}}</h6>
                      <strong class="block text-base line-height-1" [attr.aria-label]="'last-visited-center-value'">{{ checkInDetails && checkInDetails.last_visited_tenant_id ? checkedInTenant(checkInDetails.last_visited_tenant_id).name_primary_language : '-'}}</strong>
                  </div>
              </div>
          </div>
          <!-- Card -->

          <!-- Card -->
          <div class="col-6 md:col-4 lg:col-6 xl:col-4" *ngIf="false" [attr.data-testid]="'usually-seen-card'">
              <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                  <div>
                      <i class="fa fa-eye mb-2 text-xl text-600 line-height-1" [attr.aria-label]="'eye-icon'"></i>
                      <h6 class="font-medium text-700 text-xs mb-2" [attr.aria-label]="'usually-seen-label'">{{'CLIENT_CHECKIN.USUALLY_SEEN' | translate}}</h6>
                      <strong class="block text-base line-height-1" [attr.aria-label]="'usually-seen-value'">5:55 PM</strong>
                  </div>
              </div>
          </div>
          <!-- Card -->

          <!-- Card -->
          <div class="col-6 md:col-4 lg:col-6 xl:col-4" [attr.data-testid]="'last-7-days-card'">
              <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                  <div>
                      <i class="fa fa-calendar-week mb-2 text-xl text-600 line-height-1" [attr.aria-label]="'calendar-week-icon'"></i>
                      <h6 class="font-medium text-700 text-xs mb-2" [attr.aria-label]="'last-7-days-label'">{{'CLIENT_CHECKIN.LAST_SEVENT_DAYS' | translate}}</h6>
                      <strong class="block text-base line-height-1" [attr.aria-label]="'last-7-days-value'">{{checkInDetails && checkInDetails.last_7d_total_visits ? checkInDetails.last_7d_total_visits : '-'}}</strong>
                  </div>
              </div>
          </div>
          <!-- Card -->

          <!-- Card -->
          <div class="col-6 md:col-4 lg:col-6 xl:col-4" [attr.data-testid]="'last-30-days-card'">
              <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                  <div>
                      <i class="fa fa-calendar-days mb-2 text-xl text-600 line-height-1" [attr.aria-label]="'calendar-days-icon'"></i>
                      <h6 class="font-medium text-700 text-xs mb-2" [attr.aria-label]="'last-30-days-label'">{{'CLIENT_CHECKIN.LAST_30_DAYS' | translate}}</h6>
                      <strong class="block text-base line-height-1" [attr.aria-label]="'last-30-days-value'">{{checkInDetails && checkInDetails.last_30d_total_visits ? checkInDetails.last_30d_total_visits : '-'}}</strong>
                  </div>
              </div>
          </div>
          <!-- Card -->

          <!-- Card -->
          <div class="col-6 md:col-4 lg:col-6 xl:col-4" [attr.data-testid]="'last-90-days-card'">
              <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                  <div>
                      <i class="fa fa-calendar mb-2 text-xl text-600 line-height-1" [attr.aria-label]="'calendar-icon'"></i>
                      <h6 class="font-medium text-700 text-xs mb-2" [attr.aria-label]="'last-90-days-label'">{{'CLIENT_CHECKIN.LAST_90_DAYS' | translate}}</h6>
                      <strong class="block text-base line-height-1" [attr.aria-label]="'last-90-days-value'">{{ checkInDetails && checkInDetails.last_90d_total_visits ? checkInDetails.last_90d_total_visits : '-'}}</strong>
                  </div>
              </div>
          </div>
          <!-- Card -->

         
      </div>

      <!-- Content Skeleton -->
      <div *ngIf="showSkeleton" class="grid my-0" [attr.data-testid]="'checkin-stats-skeleton'">
          <!-- Card -->
          <div *ngFor="let cardSkeleton of [1,2,3,4,5,6]" class="col-6 md:col-4 lg:col-6 xl:col-4" [attr.data-testid]="'checkin-stats-skeleton-card-' + cardSkeleton">
              <div class="shadow-2 rounded p-3 text-center relative h-full flex flex-column justify-content-center">
                  <div>
                      <p-skeleton width="1rem" height="1rem" styleClass="mb-2 mx-auto" [attr.data-testid]="'skeleton-icon-' + cardSkeleton"></p-skeleton>
                      <p-skeleton width="5rem" height="1.35rem" styleClass="mb-2 mx-auto" [attr.data-testid]="'skeleton-label-' + cardSkeleton"></p-skeleton>
                      <p-skeleton width="10rem" height="1.35rem" styleClass="mx-auto" [attr.data-testid]="'skeleton-value-' + cardSkeleton"></p-skeleton>
                  </div>
              </div>
          </div>
          <!-- Card -->
      </div>
      <!-- Content Skeleton -->
  </div>
  <!-- Details -->

  <!-- Last 3 months visits -->
  <div class="my-3 md:ml-3 text-sm" *ngIf="client && (client.client_status !== clientStatus.Prospect || client.client_status.toString() !== clientStatus[clientStatus.Prospect])"
    [attr.data-testid]="'last-3-months-section'">
      <div class="surface-0 px-2">
          <!-- Header -->
          <div class="py-3 px-2 font-bold" [attr.aria-label]="'last-3-months-title'" [attr.data-testid]="'last-3-months-title'">{{'CLIENT_CHECKIN.LAST_3_MONTHS' | translate}}</div>
          <!-- Header -->

          <!-- Content -->
          <div class="grid pb-2 px-2" *ngIf="!showSkeleton" [attr.data-testid]="'last-3-months-calendars'">
              <div class="col-12 md:col-4" *ngFor="let month of defaultDates" [attr.data-testid]="'calendar-month-' + month.month">
                  <p-datepicker 
                      [inline]="true"
                      [defaultDate]="month.month"
                      icon="fa fa-calendar font-light"
                      dateFormat="M dd,yy"
                      [yearNavigator]="true"
                      yearRange="2023:2030"
                      styleClass="w-full"
                      [ngModel]="month.dates"
                      selectionMode="multiple"
                      placeholder="Select Date"
                      inputStyleClass="text-sm"
                      [attr.aria-label]="'calendar-' + month.month"
                      [attr.data-testid]="'calendar-' + month.month"
                  >
                  </p-datepicker>
              </div>
          </div>

          <!-- Content -->
          <div *ngIf="showSkeleton" class="grid pb-2 px-2" [attr.data-testid]="'last-3-months-skeleton'">
              <div *ngFor="let calendarSkeleton of [1,2,3]" class="col-12 md:col-4" [attr.data-testid]="'calendar-skeleton-' + calendarSkeleton">
                  <p-skeleton height="15rem" [attr.data-testid]="'skeleton-calendar-' + calendarSkeleton"></p-skeleton>
              </div>
          </div>
          <!-- Content -->
      </div>
  </div>
  <!-- Last 3 months visits -->

  <!-- Table -->
  <div class="my-3 md:ml-3 text-sm" *ngIf="client && (client.client_status !== clientStatus.Prospect || client.client_status.toString() !== clientStatus[clientStatus.Prospect])"
    [attr.data-testid]="'checkin-table-section'">
      <div class="surface-0">
          <p-table [value]="tableData.value" responsiveLayout="scroll" [loading]="loadingTable" [attr.data-testid]="'checkin-table'">
              <ng-template pTemplate="header">
                  <tr>
                      <th class="surface-100 py-2 border-none"><span class="text-xs text-600 white-space-nowrap" [attr.aria-label]="'date-column'">{{'CLIENT_CHECKIN.COLUMNS.DATE' | translate}}</span></th>
                      <th class="surface-100 py-2 border-none"><span class="text-xs text-600 white-space-nowrap" [attr.aria-label]="'center-column'">{{'CLIENT_CHECKIN.COLUMNS.CENTER' | translate}}</span></th>
                      <th class="surface-100 py-2 border-none"><span class="text-xs text-600 white-space-nowrap" [attr.aria-label]="'class-appointment-column'">{{'CLIENT_CHECKIN.COLUMNS.CLASS_APPOINTMENT' | translate}}</span></th>
                      <th class="surface-100 py-2 border-none"><span class="text-xs text-600 white-space-nowrap" [attr.aria-label]="'check-in-column'">{{'CLIENT_CHECKIN.COLUMNS.CHECK_IN' | translate}}</span></th>
                      <th class="surface-100 py-2 border-none"><span class="text-xs text-600 white-space-nowrap" [attr.aria-label]="'reason-column'">{{'CLIENT_CHECKIN.COLUMNS.REASON' | translate}}</span></th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-checkin>
                  <tr class="text-sm" [attr.data-testid]="'checkin-row-' + checkin.id">
                      <td class="py-2 white-space-nowrap" [attr.aria-label]="'checkin-date'">{{checkin.checkin_date_time | datetimeformat: 'MMM dd yy'}}</td>
                      <td class="py-2 white-space-nowrap" [attr.aria-label]="'checkin-center'">{{checkedInTenant(checkin.tenant_id).name_primary_language}}</td>
                      <td class="py-2 white-space-nowrap" [attr.aria-label]="'checkin-source-type'">{{checkin.source_type}}</td>
                      <td class="py-2 white-space-nowrap">
                          <p-badge *ngIf="checkin.access_status ==='Granted'" severity="success" styleClass="font-normal text-xs uppercase border-round" value="{{checkin.access_status}}"
                            [attr.aria-label]="'access-status-granted'"
                            [attr.data-testid]="'access-status-granted'"></p-badge>
                          <p-badge *ngIf="checkin.access_status ==='Denied'" severity="danger" styleClass="font-normal text-xs uppercase border-round" value="{{checkin.access_status}}"
                            [attr.aria-label]="'access-status-denied'"
                            [attr.data-testid]="'access-status-denied'"></p-badge>
                      </td>
                      <td class="py-2 white-space-nowrap" [attr.aria-label]="'access-status-reason'">{{checkin.access_status_reason}}</td>
                  </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                  <tr class="text-sm">
                      <td colspan="5" class="py-8 text-center surface-0" [attr.data-testid]="'no-checkins-message'">
                          <div class="mt-2 mb-4" [attr.aria-label]="'no-checkins-text'">{{'CLIENT_CHECKIN.NO_CHECKINS' | translate}}</div>
                          <img src="/assets/img/empty-state-datagrid-img.svg" alt="No Result Found" [attr.data-testid]="'no-checkins-image'"/>  
                      </td>
                  </tr>
              </ng-template>
          </p-table>
      </div>
  </div>
  <!-- Table -->

  <div class="text-center my-8" *ngIf="client && (client.client_status === clientStatus.Prospect || client.client_status.toString() === clientStatus[clientStatus.Prospect])"
    [attr.data-testid]="'prospect-message'">
      <div [attr.aria-label]="'prospect-message-text'">{{'CLIENT_CHECKIN.NO_FOR_PROSPECT' | translate}}</div>
      <img width="400" src="/assets/img/empty-state-datagrid-img.svg" alt="No Result Found" [attr.data-testid]="'prospect-image'"/>  
  </div>

</div>
<!-- Card -->

<!-- Biostar Enrollment Dialog -->
<p-dialog 
    [(visible)]="showEnrollmentDialog" 
    [modal]="true" 
    [header]="'BIOSTAR.ENROLLMENT_DIALOG_TITLE' | translate"
    [style]="{width: '450px', maxWidth: '90vw', height: 'auto'}"
    [closable]="true"
    (onHide)="onEnrollmentDialogHide()"
    [attr.data-testid]="'enrollment-dialog'">
    
    <div class="p-1" [formGroup]="enrollmentForm">
        <!-- Device Selection -->
        <div class="mb-3" [attr.data-testid]="'device-selection'">
            <label class="block mb-3 text-600 text-sm font-medium" [attr.aria-label]="'select-device'">{{'BIOSTAR.SELECT_DEVICE' | translate}}</label>
            <p-dropdown 
                [options]="availableDevices" 
                formControlName="device"
                optionLabel="name"
                placeholder="Select a device"
                styleClass="w-full text-sm"
                [disabled]="isScanning || enrollmentLoading"
                (onChange)="onDeviceSelected()"
                [attr.aria-label]="'device-dropdown'"
                [attr.data-testid]="'device-dropdown'">
            </p-dropdown>
        </div>

        <!-- Enrollment Type Selection -->
        <div class="mb-3" *ngIf="selectedDevice && availableEnrollmentTypes.length > 0" [attr.data-testid]="'enrollment-type-selection'">
            <label class="block mb-3 text-600 text-sm font-medium" [attr.aria-label]="'select-enrollment-type'">{{'BIOSTAR.SELECT_ENROLLMENT_TYPE' | translate}}</label>
            <div class="flex gap-1 justify-content-center flex-wrap">
                <p-button 
                    *ngFor="let type of availableEnrollmentTypes"
                    [label]="type.label" 
                    [icon]="'fa fa-' + (type.value === 'face' ? 'user' : type.value === 'fingerprint' ? 'fingerprint' : 'credit-card')"
                    [severity]="selectedEnrollmentType === type.value ? 'primary' : 'secondary'"
                    [outlined]="selectedEnrollmentType !== type.value"
                    [disabled]="isScanning || enrollmentLoading"
                    size="small"
                    styleClass="text-xs"
                    (onClick)="selectEnrollmentType(type.value)"
                    [attr.aria-label]="type.value + '-enrollment-button'"
                    [attr.data-testid]="type.value + '-enrollment-button'">
                </p-button>
            </div>
        </div>

        <!-- Scan Section -->
        <div class="mb-3">
            <!-- Scan Button -->
            <div class="text-center mb-3" *ngIf="!scanResult" [attr.data-testid]="'scan-button-section'">
                <p-button 
                    [label]="scanButtonText" 
                    [icon]="'fa fa-' + (selectedEnrollmentType === 'face' ? 'user' : selectedEnrollmentType === 'fingerprint' ? 'fingerprint' : 'credit-card')"
                    [disabled]="!selectedDevice || !selectedEnrollmentType"
                    [loading]="isScanning"
                    severity="primary"
                    size="small"
                    styleClass="font-semibold text-sm"
                    (onClick)="scanCredential()"
                    [attr.aria-label]="'scan-credential-button'"
                    [attr.data-testid]="'scan-credential-button'">
                </p-button>
            </div>

            <!-- Scan Result and Preview -->
            <div *ngIf="scanResult" [attr.data-testid]="'scan-result'">
                <div class="border-1 border-300 border-round p-3 mb-3 surface-50">
                    <div class="text-center mb-2">
                        <label class="block mb-2 text-600 text-sm font-semibold" [attr.aria-label]="'scan-preview'">{{'BIOSTAR.SCAN_PREVIEW' | translate}}</label>
                        
                        <!-- Image Preview with Quality (Horizontal Layout) -->
                        <div *ngIf="scanPreviewData && scanPreviewData.length > 0" class="flex gap-3 justify-content-center align-items-start flex-wrap" [attr.data-testid]="'scan-preview-images'">
                            <div *ngFor="let scanData of scanPreviewData; let i = index" class="flex flex-column align-items-center" [attr.data-testid]="'scan-preview-item-' + i">
                                <img [src]="scanData.image" 
                                     alt="Scanned credential preview" 
                                     class="border-round shadow-2 mb-2"
                                     style="max-width: 120px; max-height: 120px; width: auto; height: auto;"
                                     [attr.aria-label]="'scanned-credential-preview-' + i"/>
                                
                                <!-- Individual Quality Information for Fingerprints -->
                                <div *ngIf="selectedEnrollmentType === 'fingerprint' && scanData.quality" class="text-center" [attr.data-testid]="'scan-quality-info-' + i">
                                    <p class="text-xs text-600 m-0" [attr.aria-label]="'scan-quality-' + i">
                                        {{'BIOSTAR.SCAN_QUALITY' | translate}}: 
                                        <span class="font-semibold text-900">{{ scanData.quality }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="flex gap-2 justify-content-center" [attr.data-testid]="'scan-action-buttons'">
                        <p-button 
                            [label]="'BIOSTAR.CANCEL' | translate" 
                            icon="fa fa-times"
                            severity="secondary"
                            [outlined]="true"
                            size="small"
                            styleClass="text-xs"
                            (onClick)="cancelScan()"
                            [disabled]="enrollmentLoading"
                            [attr.aria-label]="'cancel-scan-button'"
                            [attr.data-testid]="'cancel-scan-button'">
                        </p-button>
                        <p-button 
                            [label]="'BIOSTAR.SCAN_AGAIN' | translate" 
                            icon="fa fa-redo"
                            severity="secondary"
                            size="small"
                            styleClass="text-xs"
                            (onClick)="scanCredential()"
                            [loading]="isScanning"
                            [disabled]="enrollmentLoading"
                            [attr.aria-label]="'scan-again-button'"
                            [attr.data-testid]="'scan-again-button'">
                        </p-button>
                        <p-button 
                            [label]="'BIOSTAR.SAVE' | translate" 
                            icon="fa fa-save"
                            severity="success"
                            size="small"
                            styleClass="font-semibold text-xs"
                            (onClick)="saveEnrollment()"
                            [loading]="enrollmentLoading"
                            [attr.aria-label]="'save-enrollment-button'"
                            [attr.data-testid]="'save-enrollment-button'">
                        </p-button>
                    </div>
                </div>
            </div>

            <!-- Loading States -->
            <div class="text-center py-3" *ngIf="isScanning" [attr.data-testid]="'scanning-loader'">
                <div class="border-1 border-300 border-round p-3 surface-50">
                    <i class="pi pi-spin pi-spinner text-primary text-2xl mb-2" [attr.aria-label]="'scanning-indicator'"></i>
                    <p class="text-sm text-600 m-0 font-medium" [attr.aria-label]="'scanning-message'">{{'BIOSTAR.SCANNING_PLEASE_WAIT' | translate}}</p>
                </div>
            </div>
        </div>
    </div>
</p-dialog>
